import { RouterPathname } from "./types";

/** A map of configured polling rates for each route in MS. To be used with `TellescopeDataSyncPollingWrapper` */
export const ROUTES_POLLING_RATE_CONFIG = {
  DEFAULT: 10000,
  "/messaging": 5000,
  "/dashboard": 5000,
} as const satisfies Partial<Record<RouterPathname | "DEFAULT", number>>;
